import { Component, OnInit, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "../../service/auth.service";
import { GeneralService } from "../../service/general.service";
import { Utility } from "../../entity/Utility";
import { FormsModule } from "@angular/forms";


@Component({
    selector: "decline-dialog",
    templateUrl: "../../../html/incs/account-number-issue-dialog.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class AccountNumberIssueDialog implements OnInit {
    public info: string = "";
    public utility: Utility|null;
    public accountNumber: string|null;
    public message: string|null = null;


    constructor(public dialogRef: MatDialogRef<AccountNumberIssueDialog>,
        private router: Router,
        private authService: AuthService,
        private generalService: GeneralService
    ) {}

    ngOnInit(): void {
        if (!this.authService.isLoggedIn()) {
            this.router.navigate(["/user/login"], { queryParams: { redirect: this.router.url } });
        }
    }

    confirm() {
        this.generalService.reportAccountNumberUsed(this.utility, this.accountNumber, this.message).then(res => {
            this.dialogRef.close();
        });
    }

    closeDialog() {
      this.dialogRef.close();
    }
}